export default {"src":"/_next/static/media/qr-code.4292a09b.svg","height":147,"width":116,"blurWidth":0,"blurHeight":0};